module.exports = __webpack_public_path__ + "img/icon-sample.ba0d4f8f.svg";